import Spy = jasmine.Spy;
import { Component, Directive, EventEmitter, Pipe, PipeTransform } from '@angular/core';

export class SpecUtil {
  static setupMock<MockObject, ReturnValue>(
    objectToMock: MockObject,
    key: any,
    returnValue: ReturnValue,
    isProperty = false
  ): Spy {
    // Note / Todo: using explicit any instead of ReturnValue due to typing issues
    // but should try to figure out so the return value is properly typed and remove the explicit any usages
    return isProperty
      ? spyOnProperty<MockObject>(objectToMock, key).and.returnValue(returnValue as any)
      : spyOn<MockObject>(objectToMock, key).and.returnValue(returnValue as any);
  }

  /**
   * Source:
   *  - https://stackoverflow.com/a/64560773/228429 (info)
   *  - https://stackoverflow.com/a/64785113/228429 (function)
   */
  static spyPropertyGetter<T, K extends keyof T>(spyObj: jasmine.SpyObj<T>, propName: K): jasmine.Spy<() => T[K]> {
    return Object.getOwnPropertyDescriptor(spyObj, propName)?.get as jasmine.Spy<() => T[K]>;
  }
}

/**
 * Examples:
 * MockComponent({ selector: 'k-mock' });
 */
export function MockComponent(options: Component): Component {
  const metadata = { ...options };
  metadata.template = metadata.template || '';
  metadata.outputs = metadata.outputs || [];
  metadata.exportAs = metadata.exportAs || '';
  metadata.providers = options.providers || [];

  class Mock {}

  metadata.outputs?.forEach?.((method) => {
    Mock.prototype[method] = new EventEmitter<any>();
  });

  return Component(metadata)(Mock as any);
}

/**
 * Examples:
 * MockDirective({ selector: '[k-mock]' });
 */
export function MockDirective(options: Component): Directive {
  const metadata: Directive = { ...options };
  metadata.selector = options.selector || '';
  metadata.inputs = options.inputs || [];
  metadata.outputs = options.outputs || [];
  metadata.providers = options.providers || [];

  class Mock {}

  metadata.outputs?.forEach?.((method) => {
    Mock.prototype[method] = new EventEmitter<any>();
  });

  return Directive(metadata)(Mock as any);
}

/**
 * Examples:
 * MockPipe('kPipe');
 */
export function MockPipe(name: string): any {
  const metadata: Pipe = { name };

  class Mock implements PipeTransform {
    transform(input: any): any {
      return input;
    }
  }

  return Pipe(metadata)(Mock as any);
}
